import type { RouteRecordRaw } from 'vue-router'

// Me 模块子页（设置 / 客服 / 积分商城 / 邀请 / 会员绑定）
export const meRoutes: RouteRecordRaw[] = [
  {
    path: '/me/pim',
    name: 'me-pim',
    component: () => import('@/pages/Me/PIM/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/pim/emergency-contact',
    name: 'me-pim-emergency-contact',
    component: () => import('@/pages/Me/PIM/EmergencyContact/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/help-center',
    name: 'me-help-center',
    component: () => import('@/pages/Me/HelpCenter/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/setting',
    name: 'me-setting',
    component: () => import('@/pages/Me/Setting/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/setting/about-ai-companion',
    name: 'me-setting-about-ai-companion',
    component: () => import('@/pages/Me/Setting/AboutAICompanion/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // PointsShop 模块
    path: '/me/points-shop',
    name: 'me-points-shop',
    component: () => import('@/pages/Me/PointsShop/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/points-shop/points-detail',
    name: 'me-points-shop-points-detail',
    component: () => import('@/pages/Me/PointsShop/PointsDetail/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/points-rules',
    name: 'me-points-rules',
    component: () => import('@/pages/Me/PointsShop/PointsRules/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/points-shop/goods-detail/:itemCode',
    name: 'me-points-shop-goods-detail',
    component: () => import('@/pages/Me/PointsShop/GoodsDetail/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/points-shop/order-detail',
    name: 'me-points-shop-order-detail',
    component: () => import('@/pages/Me/PointsShop/OrderDetail/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/points-shop/order-status',
    name: 'me-points-shop-order-status',
    component: () => import('@/pages/Me/PointsShop/OrderStatus/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/invite-friends',
    name: 'me-invite-friends',
    component: () => import('@/pages/Me/InviteFriends/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/me/music-member-bind',
    name: 'me-music-member-bind',
    component: () => import('@/pages/Me/MusicMemberBind/index.vue'),
    meta: { backMode: 'allow' },
  },
]
